import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'shared-slider-dots',
    templateUrl: './slider-dots.shared.component.html',
    styleUrls: ['./slider-dots.shared.component.scss']
})
export class SliderDotsComponent implements OnInit {
    @Input() public currentActive!: number;
    @Input() public total!: number;
    @Input() public disabled: boolean = false;
    @Output() public onDotClick: EventEmitter<{ event: Event; index: number; }> = new EventEmitter();

    constructor() { }

    ngOnInit(): void { }

    public handleDotClick($event: Event, index: number): void {
        this.onDotClick.emit({ event: $event, index });
    }

    public get dotsItems(): Array<number> {
        const arr: number[] = [];
        for (let i = 0, j = this.total || 0; i < j; i++) {
            arr.push(i);
        }

        return arr;
    }

    public get activeId(): number {
        return this.currentActive;
    }
}
